import { getShareFrom, getOriginFrom } from 'ym-reporter-vue';
import {
  generateUrl,
  getAuth,
  getAppRouteMap,
  encodeUrl,
  locationHref,
  handleRedirectAPPPage,
  isAppWebView,
} from '@/utils';

/**
 * 构建页面来源数据
 * @returns {{}}
 */
function buildPageSource() {
  const result = {};
  // 增加数据来源打点
  const origin = getOriginFrom();
  const ymsf = getShareFrom();
  if (origin !== '') {
    result.ymOriginFrom = origin;
    result.origin = origin;
  }
  if (ymsf !== '') {
    result.ymShareFrom = ymsf;
    result.ymsf = ymsf;
  }
  return result;
}

/**
 * 生成App 路由
 * @param to
 * @returns {string}
 */
export function getAppRoute(to) {
  const { name, params, query = {} } = to;
  const appRouteMap = getAppRouteMap();
  const routerName = query.name ? query.name : name;
  const route = appRouteMap.find(item => item.name === routerName);
  if (route == null) return '';
  // 构建Query
  const { appPath } = route;
  if (!isAppWebView()) {
    query['ymba-mwapi-token'] = getAuth();
  }

  // 增加数据来源打点
  const pageSource = buildPageSource();
  const appPathOptions = Object.assign(query, params, pageSource);

  // 生成URL
  return generateUrl(appPath, appPathOptions);
}

/**
 * 使用路径跳转至App
 * @param path
 * @param stay 0 -> App页面路由需要后退； 1 -> App页面路由不需要后退；
 * @returns {boolean}
 */
export function locationToAppWithPath(path, stay) {
  // 不能跳
  if (path === '') {
    return false;
  }
  // 能跳
  handleRedirectAPPPage(path, stay);
  return true;
}

/*
 * 使用路由跳转至APP
 * @param to
 * @param stay  0 -> App页面路由需要后退； 1 -> App页面路由不需要后退；
 * @returns {boolean}
 */
export function locationToAppWithRoute(to, stay = 0) {
  const path = getAppRoute(to);
  return locationToAppWithPath(path, stay);
}

/**
 * 跳转到downLoad页面中间处理URL
 * @param query
 */
export function openDownloadAppMiddleware(query) {
  const scheme = encodeUrl(getAppRoute({ query }));
  locationHref(`https://oia.youthmba.com/download/app?scheme=${scheme}`);
}
